import { render } from "./panel-2-list.vue?vue&type=template&id=22fb87bc&scoped=true"
import script from "./panel-2-list.vue?vue&type=script&lang=js"
export * from "./panel-2-list.vue?vue&type=script&lang=js"

import "./panel-2-list.vue?vue&type=style&index=0&id=22fb87bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb87bc"]])

export default __exports__